import * as React from "react";
import { Viewport, ViewSmall, ViewLarge } from "bernie-view";
import { formatText } from "bernie-l10n";

import { UitkTertiaryButton } from "uitk-react-button";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { FlexClickTracker } from "src/components/utility/analytics/FlexClickTracker/FlexClickTracker";

export function DestinationOverallRating({
  totalReviews,
  avgRating,
  toggleAllDestinationReviews,
  nameForTracking
}: {
  totalReviews: number;
  avgRating: number;
  toggleAllDestinationReviews: () => void;
  nameForTracking: string;
}) {
  const ratingDescriptor = avgRating >= 4 ? formatText("destinationReviews.topDestination") : "";

  const ButtonTracked = FlexClickTracker(UitkTertiaryButton);

  return (
    <div className="DestinationReviewAverageRating uitk-grid all-y-margin-two xl-y-margin-four l-y-margin-four all-grid-align-end all-grid-align-middle">
      <Viewport>
        <ViewSmall>
          <div className="s-cell-fill m-cell-fill">
            <p className="DestinationReviewAverageRatingText uitk-type-500">
              <span className="uitk-type-medium">{avgRating}</span>
              {"/5"}
              <span className="uitk-type-400 all-l-padding-two">{ratingDescriptor}</span>
            </p>
          </div>
        </ViewSmall>
        <ViewLarge>
          <div className="m-cell-fill all-cell-shrink">
            <p className="DestinationReviewAverageRatingText uitk-type-600">
              <span className="uitk-type-medium">{avgRating}</span>
              {"/5"}
              <span className="all-l-padding-two">{ratingDescriptor}</span>
            </p>
          </div>
        </ViewLarge>
      </Viewport>

      <ButtonTracked
        className="DestinationReviewSeeAllRatings all-cell-1-6 uitk-type-medium"
        onClick={toggleAllDestinationReviews}
        text={formatText("destinationReviews.numberOfReviews", totalReviews.toLocaleString())}
        rfrr="Default.OpenReviews"
        moduleName={nameForTracking}
        linkName="RFRR Action Event"
      >
        <UitkIcon className="all-l-padding-two" name="chevron_right" size={UitkIconSize.SMALL} />
      </ButtonTracked>
    </div>
  );
}

export default DestinationOverallRating;
